import React, { useContext, useEffect, useState } from 'react';
import { Card, Col, Image, Row } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { LocaleContext } from 'routes/Router';
import Shimmer from 'components/commom/Shimmer';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import Loader from 'components/commom/Loader';
import SelectInputBorder from 'components/commom/SelectInputBorder';
import LabelWithInput from 'components/commom/LabelWithInput';
import ReusableButton from 'components/commom/Button';
import { getProviderListData } from 'store/providerList/providerListAction';
import { ClearTokenRedirectLogin } from 'utils/general';
import { useDispatch, useSelector } from 'react-redux';
import CommonToast from 'components/commom/CommonToast';
import { useNavigate } from 'react-router-dom';
import { getConsultationHistoryCallAPI } from 'store/getConsultationHistory/getConsultationHistoryAction';
import { updateDoctorEarningDataCallAPI } from 'store/updateDoctorEarning/updateDoctorEarningAction';
import { downloadConsultationHistoryCallAPI } from 'store/downloadConsultationHistory/downloadConsultationHistoryAction';
import moment from 'moment';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import CheckIcon from 'assets/images/check.svg';
import HistoryIcon from 'assets/images/history.svg';
import StampIcon from 'assets/images/stamp.svg';

function DoctorEarning() {
  const selectDateList = [
    {
      id: 'Today',
      name: 'Today',
    },
    {
      id: 'Yesterday',
      name: 'Yesterday',
    },
    {
      id: 'Last 7 Days',
      name: 'Last 7 Days',
    },
    {
      id: 'Last 15 Days',
      name: 'Last 15 Days',
    },
    {
      id: 'Last 30 Days',
      name: 'Last 30 Days',
    },
    {
      id: 'Custom',
      name: 'Custom',
    },
  ];

  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const { locale } = useContext(LocaleContext);
  const intl = useIntl();
  const navigate = useNavigate();
  const [applyBtn, setApplyBtn] = useState(false);
  const [downloadBtn, setDownloadBtn] = useState(false);
  const [selectedDate, setSelectedDate] = useState();
  const [formData, setFormData] = useState({
    doctor: '',
    startDate: '',
    endDate: '',
  });
  const [formId, setFormId] = useState({
    doctor: '',
  });
  const [count, setCount] = useState(0);
  const [providerList, setProviderList] = useState([]);
  const [consultationHistoryList, setConsultationHistoryList] = useState([]);
  const [isAllPaid, setIsAllPaid] = useState(false);
  const [isAllMarkPaid, setIsAllMarkPaid] = useState(false);
  const itemsPerPage = 10;

  const consultationHistoryLoader = useSelector(
    (state) => state?.getConsultationHistoryReducer?.loading
  );

  const downloadConsultationHistoryLoader = useSelector(
    (state) => state?.downloadConsultationHistoryReducer?.loading
  );

  useEffect(() => {
    getProviderList();
  }, []);

  const getProviderList = (
    pageValue,
    countryName,
    stateName,
    cityName,
    titleName
  ) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setProviderList(res?.data);
        setCount(Math.ceil(res?.count / itemsPerPage));
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(
      getProviderListData(
        external,
        pageValue,
        countryName,
        stateName,
        cityName,
        titleName
      )
    );
  };

  const handleChange = (event) => {
    const { name, value } = event?.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value?.provider_name,
    }));
    setFormId((prev) => ({
      ...prev,
      [name]: value?.id,
    }));
    setDownloadBtn(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setDownloadBtn(false);
  };

  const handleDateChange = (e) => {
    setSelectedDate(e?.target?.value);

    switch (e?.target?.value?.id) {
      case 'Today':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        break;

      case 'Yesterday':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(1, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().subtract(1, 'days').format('YYYY-MM-DD'),
        }));
        break;

      case 'Last 7 Days':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(6, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        break;

      case 'Last 15 Days':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(14, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        break;

      case 'Last 30 Days':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(29, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        break;

      default:
        break;
    }
  };

  const handleApply = () => {
    setApplyBtn(true);
    const data =
      formId?.doctor +
      '/?start_date=' +
      formData?.startDate +
      '&end_date=' +
      formData?.endDate;
    const external = {
      run: true,
      handleFunction: (res) => {
        setConsultationHistoryList(res?.data);

        const allPaid =
          res?.data?.consultation_history.length > 0 &&
          res?.data?.consultation_history.every(
            (item) => item.payment_status === true
          );

        setIsAllPaid(allPaid);
        if (res?.data?.consultation_history.length > 0) {
          setIsAllMarkPaid(true);
        }
        setDownloadBtn(true);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        setIsAllMarkPaid(false);
        showToast(res?.message, 'error');
      },
    };
    dispatch(getConsultationHistoryCallAPI(external, data));
  };

  const downloadConsultationReport = (consultationHistoryList) => {
    const data =
      formId?.doctor +
      '/?start_date=' +
      formData?.startDate +
      '&end_date=' +
      formData?.endDate +
      '&is_download=1';

    const external = {
      run: true,
      isDownload: true,
      handleFunction: (res) => {
        const timestamp = new Date().getTime();
        const randomString = Math.random().toString(36).substring(2, 8);
        const fileName = `report_${timestamp}_${randomString}.pdf`;

        const blob = new Blob([res], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };

    dispatch(downloadConsultationHistoryCallAPI(external, data));
  };

  const updatePaymentStatus = (status = false, appointmentId = '') => {
    if (!status) {
      const data = {
        appointment_id: appointmentId,
        start_date: formData?.startDate,
        end_date: formData?.endDate,
      };

      const external = {
        run: true,
        providerId: formId?.doctor,
        handleFunction: (res) => {
          showToast(res?.message, 'success');
          handleApply();
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      };

      dispatch(updateDoctorEarningDataCallAPI(external, data));
    }
  };

  return (
    <>
      <Row
        className="mt-3 mb-5 g-5"
        style={{ display: 'flex', alignItems: 'center' }}
      >
        <Col md={2} className="mt-4">
          <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
            Doctor:
          </div>
          <div>
            <SelectInputBorder
              placeholder={intl.formatMessage({
                id: 'Doctor',
              })}
              name={'doctor'}
              value={formData?.doctor}
              data={providerList}
              onChange={(e) => handleChange(e)}
              background={'#FFFFFF'}
              colorIcon={'#292D32'}
              placeholderColor={'#292D32'}
            />
          </div>
        </Col>
        <Col md={2} className="mt-4">
          <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
            {'Select Date:'}
          </div>
          <div>
            <SelectInputBorder
              placeholder={intl.formatMessage({
                id: 'Select Date',
              })}
              name={'selectDate'}
              value={selectedDate?.id || ''}
              data={selectDateList}
              onChange={(e) => handleDateChange(e)}
              background={'#FFFFFF'}
              colorIcon={'#292D32'}
              placeholderColor={'#292D32'}
            />
          </div>
        </Col>
        {selectedDate?.id === 'Custom' && (
          <>
            <Col md={2} className="mt-2">
              <div>
                <LabelWithInput
                  label="Start Date"
                  type="date"
                  name="startDate"
                  value={formData?.startDate}
                  disabled={false}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
              </div>
            </Col>
            <Col md={2} className="mt-2">
              <div>
                <LabelWithInput
                  label="End Date"
                  type="date"
                  name="endDate"
                  value={formData?.endDate}
                  disabled={false}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
              </div>
            </Col>
          </>
        )}
        <Col md={2} className="mt-5">
          <ReusableButton
            fullWidth={true}
            variant="contained"
            color="#F5F5F5"
            fontSize="16px"
            fontWeight="500"
            padding="12px 50px"
            height="44px"
            bgColor="#375241"
            brColor="#375241"
            fontFamily="outfit_regular"
            loading={consultationHistoryLoader}
            onClick={() => {
              handleApply();
            }}
            disabled={
              !formData?.doctor || !formData?.startDate || !formData?.endDate
            }
          >
            <FormattedMessage id="Apply" />
          </ReusableButton>
        </Col>
        <Col md={2} className="mt-5">
          <ReusableButton
            fullWidth={true}
            variant="contained"
            color="#F5F5F5"
            fontSize="16px"
            fontWeight="500"
            padding="12px 50px"
            height="44px"
            bgColor="#375241"
            brColor="#375241"
            fontFamily="outfit_regular"
            loading={downloadConsultationHistoryLoader}
            onClick={() => downloadConsultationReport(consultationHistoryList)}
            disabled={
              !formData?.doctor ||
              !formData?.startDate ||
              !formData?.endDate ||
              consultationHistoryLoader ||
              !downloadBtn ||
              consultationHistoryList?.consultation_history?.length === 0
            }
          >
            <FormattedMessage id="Download" />
          </ReusableButton>
        </Col>
        <Col md={3} className="mt-5">
          <ReusableButton
            fullWidth={true}
            variant="contained"
            color="#FFFFFF"
            fontSize="16px"
            fontWeight="500"
            padding="12px 50px"
            height="44px"
            bgColor="#2B8F50"
            brColor="#2B8F50"
            fontFamily="outfit_regular"
            onClick={() => updatePaymentStatus()}
            disabled={!isAllMarkPaid}
          >
            <>
              <Image
                src={CheckIcon}
                alt="icon"
                style={{ marginRight: '5px' }}
              />
              <FormattedMessage id="Mark all as payment done" />
            </>
          </ReusableButton>
        </Col>
      </Row>
      <Row className="g-3" style={{ alignItems: 'center' }}>
        <Col lg={4} xl={3} md={6} sm={12}>
          <Card className={locale === 'en' ? 'text-start' : 'text-end'}>
            <Card.Body>
              <div className="flex justify-between">
                <div>
                  <div className="fs-16 fc-292D32 lh-201 family_outfit_regular_400">
                    <FormattedMessage id="Total Patients" />
                  </div>
                  <div className="pt-8 fs-28 lh-3528 fc-3C3C3C family_outfit_regular_500">
                    {consultationHistoryLoader ? (
                      <Shimmer width="250px" height="20px" marginTop="8px" />
                    ) : (
                      consultationHistoryList?.total_patient
                    )}
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={4} xl={3} md={6} sm={12}>
          <Card className={locale === 'en' ? 'text-start' : 'text-end'}>
            <Card.Body>
              <div className="flex justify-between">
                <div>
                  <div className="fs-16 fc-292D32 lh-201 family_outfit_regular_400">
                    <FormattedMessage id="Total Consultation" />
                  </div>
                  <div className="pt-8 fs-28 lh-3528 fc-3C3C3C family_outfit_regular_500">
                    {consultationHistoryLoader ? (
                      <Shimmer width="250px" height="20px" marginTop="8px" />
                    ) : (
                      consultationHistoryList?.total_consultation
                    )}
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={4} xl={3} md={6} sm={12}>
          <Card className={locale === 'en' ? 'text-start' : 'text-end'}>
            <Card.Body>
              <div className="flex justify-between">
                <div>
                  <div className="fs-16 fc-292D32 lh-201 family_outfit_regular_400">
                    <FormattedMessage id="Net Paid to Doctor" />
                  </div>
                  <div className="pt-8 fs-28 lh-3528 fc-3C3C3C family_outfit_regular_500">
                    {consultationHistoryLoader ? (
                      <Shimmer width="250px" height="20px" marginTop="8px" />
                    ) : (
                      consultationHistoryList?.total_net_payment
                    )}
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        {isAllPaid && (
          <>
            <Col lg={4} xl={1} md={3} sm={12}></Col>
            <Col lg={4} xl={2} md={3} sm={12}>
              <Image src={StampIcon} alt="icon" width="150" height="150" />
            </Col>
          </>
        )}
      </Row>
      <div className="pt-40">
        <>
          <Row className="listCustomHeader m-0 p-0 flex items-center">
            <Col lg={2} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Consultation Date" />
              </p>
            </Col>
            <Col lg={2} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Patient Name" />
              </p>
            </Col>
            <Col lg={2} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Appointment Fee" />
              </p>
            </Col>
            <Col lg={2} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Platform Fee" />
              </p>
            </Col>
            <Col lg={2} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Net Amount" />
              </p>
            </Col>
            <Col lg={2} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Payment" />
              </p>
            </Col>
          </Row>
          {!applyBtn ? (
            <div className="flex justify-center pt-40">
              <div>
                <Image src={EmptyScreen} alt="icon" />
                <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center pt-30">
                  Nothing here yet
                </div>
              </div>
            </div>
          ) : consultationHistoryLoader ? (
            <Loader marginTop={'10vh'} />
          ) : consultationHistoryList &&
            consultationHistoryList?.consultation_history?.length > 0 ? (
            <>
              <Row className="bc-FFFFFF m-0 p-0">
                {consultationHistoryList?.consultation_history?.map(
                  (item, index) => {
                    return (
                      <Row
                        className="m-0 p-0 flex items-center listAppointment"
                        style={{
                          borderLeft: `8px solid ${item?.status === 'Completed' ? '#375241' : '#CA1B00'}`,
                        }}
                      >
                        <Col lg={2} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_medium_500 lh-176 flex items-center">
                            {moment(item?.appointment_date_time).format(
                              'DD/MM/YYYY'
                            )}
                          </div>
                        </Col>
                        <Col lg={2} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176 break-all ...">
                            {item?.patient?.full_name}
                          </div>
                        </Col>
                        <Col lg={2} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                            {item?.appointment_fee}
                          </div>
                        </Col>
                        <Col lg={2} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_medium_500 lh-176 flex items-center">
                            {item?.platform_fee}
                          </div>
                        </Col>
                        <Col lg={2} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_medium_500 lh-176 flex items-center">
                            {item?.net_ammount}
                          </div>
                        </Col>
                        <Col lg={2} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_medium_500 lh-176 flex items-center">
                            <ReusableButton
                              fullWidth={false}
                              variant="outlined"
                              color="#FFFFFF"
                              fontSize="14px"
                              fontWeight="500"
                              padding="14px 24px"
                              borderRadius="0px"
                              height="28px"
                              bgColor={
                                item?.payment_status ? '#2B8F50' : '#E2B30A'
                              }
                              brColor={
                                item?.payment_status ? '#2B8F50' : '#E2B30A'
                              }
                              fontFamily="outfit_medium"
                              onClick={() =>
                                updatePaymentStatus(
                                  item?.payment_status,
                                  item?.id
                                )
                              }
                            >
                              {item?.payment_status ? (
                                <>
                                  <Image
                                    src={CheckIcon}
                                    alt="icon"
                                    style={{ marginRight: '5px' }}
                                  />
                                  <FormattedMessage id="Done" />
                                </>
                              ) : (
                                <>
                                  <Image
                                    src={HistoryIcon}
                                    alt="icon"
                                    style={{ marginRight: '5px' }}
                                  />
                                  <FormattedMessage id="Pending" />
                                </>
                              )}
                            </ReusableButton>
                          </div>
                        </Col>
                      </Row>
                    );
                  }
                )}
              </Row>
            </>
          ) : (
            <div className="flex justify-center pt-40">
              <div>
                <Image src={EmptyScreen} alt="icon" />
                <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center pt-30">
                  Nothing here yet
                </div>
              </div>
            </div>
          )}
        </>
      </div>
    </>
  );
}

export default DoctorEarning;
